(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jgid-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];

    function firstDow(year, month, dow) {
      var d = new Date(year, month, 1, 8, 0, 0, 0);
      d.setDate(1 + ((dow - d.getDay() + 7) % 7));
      return d;
    }

    function endOfDay(d) {
      var e = new Date(d.getTime());
      e.setHours(23, 59, 59, 999);
      return e;
    }

    function buildWindow(year, month, mode) {
      var start, end;
      if (mode === 'first_sunday') {
        start = firstDow(year, month, 0);
        end = endOfDay(start);
      } else if (mode === 'first_saturday') {
        start = firstDow(year, month, 6);
        end = endOfDay(start);
      } else {
        start = firstDow(year, month, 6);
        end = new Date(start.getTime());
        end.setDate(start.getDate() + 1);
        end = endOfDay(end);
      }
      return { start: start, end: end };
    }

    function parseStart(raw, mode) {
      if (!raw) return null;
      var m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(raw.trim());
      if (!m) return null;
      var start = new Date(+m[1], +m[2] - 1, +m[3], 8, 0, 0, 0);
      if (isNaN(start.getTime())) return null;
      var end = new Date(start.getTime());
      if (mode === 'first_weekend') end.setDate(start.getDate() + 1);
      return { start: start, end: endOfDay(end) };
    }

    function nextWindow(now, mode, startRaw) {
      var pinned = parseStart(startRaw, mode);
      if (pinned && now <= pinned.end) return pinned;

      var y = now.getFullYear();
      var m = now.getMonth();
      var w = buildWindow(y, m, mode);
      if (now > w.end) {
        m += 1;
        if (m > 11) { m = 0; y += 1; }
        w = buildWindow(y, m, mode);
      }
      if (pinned && w.start < pinned.start) return pinned;
      return w;
    }

    function label(w, mode) {
      var s = w.start, e = w.end;
      if (mode === 'first_weekend') {
        if (s.getMonth() === e.getMonth()) {
          return s.getDate() + ' & ' + e.getDate() + ' ' + MONTHS[s.getMonth()] + ' ' + s.getFullYear();
        }
        return s.getDate() + ' ' + MONTHS[s.getMonth()] + ' & ' + e.getDate() + ' ' + MONTHS[e.getMonth()] + ' ' + e.getFullYear();
      }
      var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
      return days[s.getDay()] + ' ' + s.getDate() + ' ' + MONTHS[s.getMonth()] + ' ' + s.getFullYear();
    }

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function init(root) {
      var mode = root.getAttribute('data-mode') || 'first_sunday';
      var startRaw = root.getAttribute('data-start') || '';
      var dateEl = root.querySelector('[data-jgid-date]');
      var clockEl = root.querySelector('[data-jgid-clock]');
      var liveEl = root.querySelector('[data-jgid-live]');
      if (!dateEl || !clockEl) return;

      var units = {
        days: clockEl.querySelector('[data-unit="days"]'),
        hours: clockEl.querySelector('[data-unit="hours"]'),
        minutes: clockEl.querySelector('[data-unit="minutes"]'),
        seconds: clockEl.querySelector('[data-unit="seconds"]')
      };

      function tick() {
        var now = new Date();
        var w = nextWindow(now, mode, startRaw);
        dateEl.textContent = label(w, mode);

        if (now >= w.start && now <= w.end) {
          clockEl.hidden = true;
          if (liveEl) liveEl.hidden = false;
          return;
        }
        clockEl.hidden = false;
        if (liveEl) liveEl.hidden = true;

        var t = Math.floor(Math.max(0, w.start - now) / 1000);
        units.days.textContent = String(Math.floor(t / 86400));
        units.hours.textContent = pad(Math.floor((t % 86400) / 3600));
        units.minutes.textContent = pad(Math.floor((t % 3600) / 60));
        units.seconds.textContent = pad(t % 60);
      }

      tick();
      setInterval(tick, 1000);
    }

    function boot() {
      document.querySelectorAll('[data-jgid-countdown]').forEach(function (el) {
        if (el.dataset.jgidReady === 'true') return;
        el.dataset.jgidReady = 'true';
        init(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
